import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export default function usePublicDataPools() {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['datapools', { public: true }],

    queryFn: async () =>
      (await glynt).dataPool.list({
        public: true,
        advanced: true,
      }),

    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60,
    placeholderData: keepPreviousData
  });
}
